module.exports = __webpack_public_path__ + "product/design-template-download-6b188706c1d44f629af6fec845a3cba9.webp";